<template>
  <div class='cdn-manage'>
      <div class="my-table">
        <InnerTable
         :data="tableData"
         @selectedRows="selectedRows"
         :isCheckedRowShow="true"
          >
        <template slot-scope="{ item }">
          <TableColumn label="姓名">{{ item.name }}</TableColumn>
          <TableColumn label="日期" sortlabel="date">{{ item.date }}</TableColumn>
          <TableColumn label="地址">{{ item.address }}</TableColumn>
        </template>
      </InnerTable>

      <div class="pagination-bottom">
        <Pagination
        :total="1000"
        :page-size="20"
        :page-count="11"
        @change="handleChange"
      />
      </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    setTimeout(() => {
      this.tableData = [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
      ];
    }, 1000);
  },
  methods: {
    selectedRows(rows) {
      console.log('*****', rows);
    },
    handleChange(e) {
      console.log('pagination', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  .cdn-manage {
    .my-table {
    width: 1000px;
    margin: 26px auto;
    }
    .pagination-bottom {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-top: 17px;
    }
  }
</style>
